import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';
import bibleIcon from '../images/image.png';

const TermsOfService = () => {
  return (
    <div className="terms-page">
      {/* Header */}
      <header className="terms-header">
        <div className="header-content">
          <Link to="/" className="header-link">
            <img src={bibleIcon} alt="Bible Bro" className="header-logo" />
            <h1 className="header-title">Bible Bro</h1>
          </Link>
        </div>
      </header>

      {/* Terms Content */}
      <main className="terms-content">
        <div className="container">
          <div className="terms-header-section">
            <div className="cross-icon-large">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 2v20M2 12h20" strokeLinecap="round"/>
              </svg>
            </div>
            <h1 className="terms-title">Terms of Service</h1>
            <p className="terms-last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          <div className="terms-body">
            <section className="terms-section">
              <h2 className="section-heading">1. Acceptance of Terms</h2>
              <p className="terms-text">
                By accessing, downloading, installing, or using the Bible Bro mobile application 
                ("App"), you agree to be bound by these Terms of Service ("Terms"). If you do not 
                agree to these Terms, you must not use the App. Your use of the App constitutes 
                your acceptance of these Terms and your agreement to comply with all applicable 
                laws and regulations.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">2. Ownership and Operator</h2>
              <p className="terms-text">
                The Bible Bro application is owned and operated by <strong>Astrid Genesis LLC</strong> 
                ("Company", "we", "us", or "our"). All rights, title, and interest in and to the 
                App, including all intellectual property rights, are and will remain the exclusive 
                property of Astrid Genesis LLC.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">3. Use of the Application</h2>
              <p className="terms-text">
                The Bible Bro App provides various features including, but not limited to:
              </p>
              <ul className="terms-list">
                <li>AI-powered chatbot functionality ("Bible Bro" chatbot)</li>
                <li>Bible quiz features with thousands of questions</li>
                <li>Bible reading plans and daily Scripture content</li>
                <li>Progress tracking and user engagement features</li>
              </ul>
              <p className="terms-text">
                You agree to use the App only for lawful purposes and in accordance with these Terms. 
                You are responsible for all activities that occur under your account or through your 
                use of the App.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">4. Disclaimer of Liability for Chatbot Interactions</h2>
              <p className="terms-text">
                <strong>IMPORTANT:</strong> The Bible Bro chatbot is an AI-powered service designed 
                to provide general information, encouragement, and responses to Bible-related questions. 
                By using the chatbot feature, you acknowledge and agree that:
              </p>
              <ul className="terms-list">
                <li>
                  <strong>Astrid Genesis LLC is not responsible</strong> for any content, advice, 
                  interpretations, or responses generated by the chatbot.
                </li>
                <li>
                  The chatbot's responses are generated by artificial intelligence and may contain 
                  errors, inaccuracies, or opinions that do not reflect the views of Astrid Genesis LLC.
                </li>
                <li>
                  You should not rely solely on the chatbot for theological guidance, spiritual 
                  counseling, or critical life decisions.
                </li>
                <li>
                  The chatbot is not a substitute for professional pastoral care, biblical scholarship, 
                  or personal study of Scripture.
                </li>
                <li>
                  <strong>Astrid Genesis LLC disclaims all liability</strong> for any consequences, 
                  decisions, or actions taken based on information or advice received through the 
                  chatbot.
                </li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">5. User Misuse and Responsibility</h2>
              <p className="terms-text">
                You are solely responsible for your use of the App and any content you submit, 
                share, or generate through the App. Astrid Genesis LLC is <strong>not responsible</strong> 
                for:
              </p>
              <ul className="terms-list">
                <li>Any misuse of the App by you or any other user</li>
                <li>Any inappropriate, harmful, or illegal use of the App's features</li>
                <li>Any consequences resulting from your interactions with the chatbot or other App features</li>
                <li>Any decisions made or actions taken based on your use of the App</li>
                <li>Any content you create, share, or distribute through the App</li>
                <li>Any violation of these Terms or applicable laws by you or other users</li>
              </ul>
              <p className="terms-text">
                You agree to use the App in a manner that is consistent with its intended purpose 
                and in compliance with all applicable laws, regulations, and ethical standards.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">6. Limitation of Liability</h2>
              <p className="terms-text">
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, <strong>ASTRID GENESIS LLC SHALL 
                NOT BE LIABLE</strong> for any indirect, incidental, special, consequential, or punitive 
                damages, or any loss of profits or revenues, whether incurred directly or indirectly, 
                or any loss of data, use, goodwill, or other intangible losses, resulting from:
              </p>
              <ul className="terms-list">
                <li>Your use or inability to use the App</li>
                <li>Your interactions with the Bible Bro chatbot or any other App features</li>
                <li>Any unauthorized access to or use of our servers and/or any personal information stored therein</li>
                <li>Any bugs, viruses, trojan horses, or the like that may be transmitted through the App</li>
                <li>Any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content</li>
                <li>Any user-generated content or conduct of any third party on or through the App</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">7. Disclaimer of Warranties</h2>
              <p className="terms-text">
                THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
                EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF 
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR COURSE OF 
                PERFORMANCE. Astrid Genesis LLC does not warrant that:
              </p>
              <ul className="terms-list">
                <li>The App will be uninterrupted, secure, or error-free</li>
                <li>Any defects or errors will be corrected</li>
                <li>The App is free of viruses or other harmful components</li>
                <li>The results obtained from using the App will be accurate or reliable</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">8. Indemnification</h2>
              <p className="terms-text">
                You agree to defend, indemnify, and hold harmless Astrid Genesis LLC, its officers, 
                directors, employees, agents, and affiliates from and against any claims, liabilities, 
                damages, losses, and expenses, including without limitation reasonable legal and 
                accounting fees, arising out of or in any way connected with:
              </p>
              <ul className="terms-list">
                <li>Your access to or use of the App</li>
                <li>Your violation of these Terms</li>
                <li>Your violation of any third-party right, including without limitation any intellectual 
                property right, publicity, confidentiality, property, or privacy right</li>
                <li>Your misuse of the App or any of its features, including the chatbot</li>
                <li>Any content you submit, post, or transmit through the App</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">9. Modifications to Terms</h2>
              <p className="terms-text">
                Astrid Genesis LLC reserves the right to modify these Terms at any time. We will 
                notify users of any material changes by updating the "Last Updated" date at the 
                top of this page. Your continued use of the App after any such modifications 
                constitutes your acceptance of the modified Terms.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">10. Termination</h2>
              <p className="terms-text">
                Astrid Genesis LLC reserves the right to terminate or suspend your access to the 
                App immediately, without prior notice or liability, for any reason whatsoever, 
                including without limitation if you breach these Terms.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">11. Governing Law</h2>
              <p className="terms-text">
                These Terms shall be governed by and construed in accordance with the laws of the 
                jurisdiction in which Astrid Genesis LLC is incorporated, without regard to its 
                conflict of law provisions.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">12. Contact Information</h2>
              <p className="terms-text">
                If you have any questions about these Terms of Service, please contact Astrid Genesis LLC 
                through the appropriate channels provided in the App or through our official website.
              </p>
            </section>

            <section className="terms-section">
              <h2 className="section-heading">13. Acknowledgment</h2>
              <p className="terms-text terms-acknowledgment">
                <strong>BY USING THE BIBLE BRO APP, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, 
                AND AGREE TO BE BOUND BY THESE TERMS OF SERVICE.</strong> You understand that Astrid 
                Genesis LLC is not responsible for any consequences resulting from your use of the App, 
                including but not limited to your interactions with the chatbot, your misuse of the App, 
                or any decisions made based on information obtained through the App.
              </p>
            </section>
          </div>

          <div className="terms-footer-actions">
            <Link to="/" className="back-button">
              ← Back to Home
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="terms-footer">
        <div className="container">
          <p className="footer-text">
            © {new Date().getFullYear()} Astrid Genesis LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;

